var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { maxLength, required, useForm, useModel } from '@veeam/core';
import styled from 'styled-components';
import { GrowView } from "../layouts";
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { FormLayout } from "../FormLayout";
import { CheckboxField, PasswordField, TextField } from "../fields";
import { Button } from "../Button";
import { ErrorMessage } from "../ErrorMessage";
import { Notification, NOTIFICATION_STATUS } from "../Notification";
import { useAutoFocus, useCapsLockDetector, useLoginFormSubmit } from "./hooks";
import { Spinner } from "../Spinner";
import { Link, LINK_TARGET } from "../Link";
import { INDENT } from "../View";
import { CONTROL_SIZE } from "../common/public";
var DEFAULT_TEXTS = {
    placeholderLogin: 'Username',
    placeholderPassword: 'Password',
    rememberMe: 'Remain logged in',
    actionLogIn: 'Log in',
    actionForgotPassword: 'Forgot password?',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    warningCapsLockOn: 'Caps Lock is on',
    warningSessionExpired: 'Your session has expired'
};
var LoginButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 112px;\n"], ["\n    min-width: 112px;\n"])));
export function LoginMain(_a) {
    var initialValues = _a.initialValues, loading = _a.loading, forgotPasswordUrl = _a.forgotPasswordUrl, _b = _a.forgotPasswordTarget, forgotPasswordTarget = _b === void 0 ? LINK_TARGET.blank : _b, forgotPasswordOnClick = _a.forgotPasswordOnClick, logIn = _a.logIn, busyModel = _a.busyModel, onRequestMFACode = _a.onRequestMFACode, isExpired = _a.isExpired, notificationMessage = _a.notificationMessage, hasRememberMe = _a.hasRememberMe, customTexts = _a.texts, externalError = _a.error;
    var texts = Object.assign({}, DEFAULT_TEXTS, customTexts);
    var inputRef = useAutoFocus();
    var form = useForm({
        login: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.login) || '',
        password: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.password) || '',
        rememberMe: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.rememberMe) || false
    }, {
        validationSchema: {
            login: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)],
            password: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)]
        }
    });
    var internalLoading = useModel(busyModel).value.loading;
    var _c = useLoginFormSubmit({
        form: form,
        handler: logIn,
        busyModel: busyModel,
        error: externalError,
        onRequestMFACode: function () { return onRequestMFACode(form.getValue().login); }
    }), submit = _c.submit, isSubmitted = _c.isSubmitted, errorHighlight = _c.errorHighlight, fieldFocusHandler = _c.fieldFocusHandler, keyDownHandler = _c.keyDownHandler, hasError = _c.hasError, error = _c.error;
    loading = loading || internalLoading;
    var isCapsLockActive = useCapsLockDetector();
    var needShowExpiredWarning = isExpired && !isSubmitted; //
    var hasWarning = isCapsLockActive || needShowExpiredWarning;
    var hasMessages = notificationMessage || hasError || hasWarning;
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, spaceTop: hasMessages ? INDENT.none : INDENT.m, onKeyDown: keyDownHandler },
        React.createElement(StackView, { align: STACK_ALIGN.start, direction: STACK_DIRECTION.column, gap: STACK_GAP.s },
            notificationMessage && !needShowExpiredWarning && (React.createElement(Notification, { status: typeof notificationMessage === 'string'
                    ? NOTIFICATION_STATUS.warning
                    : notificationMessage.type }, typeof notificationMessage === 'string'
                ? notificationMessage
                : notificationMessage.text)),
            hasError && React.createElement(ErrorMessage, null, error),
            needShowExpiredWarning && (React.createElement(Notification, { status: NOTIFICATION_STATUS.warning }, texts.warningSessionExpired)),
            isCapsLockActive && (React.createElement(Notification, { status: NOTIFICATION_STATUS.warning }, texts.warningCapsLockOn))),
        React.createElement(FormLayout, { disabled: loading },
            React.createElement(TextField, { field: form.fields.login, validateAfterTouch: false, controlRef: inputRef, placeholder: texts.placeholderLogin, size: CONTROL_SIZE.full, hasError: errorHighlight, onFocus: fieldFocusHandler }),
            React.createElement(PasswordField, { field: form.fields.password, validateAfterTouch: false, placeholder: texts.placeholderPassword, size: CONTROL_SIZE.full, hasError: errorHighlight, onFocus: fieldFocusHandler }),
            hasRememberMe && (React.createElement(CheckboxField, { field: form.fields.rememberMe, label: texts.rememberMe }))),
        React.createElement(StackView, { spaceTop: hasRememberMe ? INDENT.none : INDENT.s, direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center },
            React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center },
                React.createElement(LoginButton, { onClick: submit, disabled: loading }, texts.actionLogIn),
                loading && React.createElement(Spinner, null)),
            React.createElement(GrowView, null),
            forgotPasswordUrl && (React.createElement(Link, { href: forgotPasswordUrl || '', onClick: forgotPasswordOnClick, target: forgotPasswordTarget, disabled: loading }, texts.actionForgotPassword)))));
}
var templateObject_1;
//# sourceMappingURL=LoginMain.js.map